// Packages
import styled from "styled-components";

export const SectionContainer = styled.section(
  ({ theme, $reverse, $noPadding }) => ({
    display: "flex",
    flexDirection: "column",
    gap: "40px",

    [theme.breakpoint.lg()]: {
      flexDirection: $reverse ? "row-reverse" : "row",
      paddingTop: $noPadding ? "0" : "",
      paddingBottom: $noPadding ? "0" : "",
    },
  })
);

export const SectionImageContent = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flex: 0,
  maxWidth: "100%",

  [theme.breakpoint.lg()]: {
    flex: 1,
    justifyContent: "flex-end",
    maxWidth: "50%",
  },
}));

export const SectionImage = styled.img(({ theme }) => ({
  maxWidth: "100%",
  width: "100%",
  objectFit: "cover",
  height: "auto",
}));

export const SectionBlockContent = styled.div(({ theme }) => ({
  flex: 1,
  maxWidth: "100%",

  [theme.breakpoint.lg()]: {
    maxWidth: "50%",
    flexDirection: "row",
  },
}));
